var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgButtereye(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 241,
    height: 241,
    viewBox: "0 0 241 241",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-52 -1129.457)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M51,0h0a0,0,0,0,1,0,0V95a0,0,0,0,1,0,0H0a0,0,0,0,1,0,0V51A51,51,0,0,1,51,0Z",
    transform: "translate(147 1129.457)",
    fill: "#00c68a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46,0h5a0,0,0,0,1,0,0V49A46,46,0,0,1,5,95H0a0,0,0,0,1,0,0V46A46,46,0,0,1,46,0Z",
    transform: "translate(147 1275.457)",
    fill: "#00c68a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51,0H95a0,0,0,0,1,0,0V51a0,0,0,0,1,0,0H0a0,0,0,0,1,0,0v0A51,51,0,0,1,51,0Z",
    transform: "translate(198 1224.457)",
    fill: "#00c68a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0H95a0,0,0,0,1,0,0V51a0,0,0,0,1,0,0H46A46,46,0,0,1,0,5V0A0,0,0,0,1,0,0Z",
    transform: "translate(52 1224.457)",
    fill: "#00c68a"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgButtereye);
export default __webpack_public_path__ + "static/media/buttereye.d32abdb6.svg";
export { ForwardRef as ReactComponent };